import { LocalStorage, SessionStorage } from 'quasar';
import { RULE_MANAGER } from 'src/constants';
import { logout, clearStorageForLogout } from 'src/utils/LogoutUtil';

export default {
    methods: {
        logout,
        clearStorageForLogout,

        clearStorageForRefresh() {
            SessionStorage.remove('sub_org_id');
            SessionStorage.remove('doc_types_sub_types');
            SessionStorage.remove('organizations');
            SessionStorage.remove('acls');
            SessionStorage.remove('sub_app');
            SessionStorage.remove('sub_types');
        },

        setDataToLocalStorage(key : string, obj: any) {
            LocalStorage.set(key, obj);
        },

        getDataByKey(key : string) {
            return LocalStorage.getItem(key);
        },
        removeDataFromLocalStorage(key : string) {
            LocalStorage.remove(key);
        },

        async clearSelectedSessionStorage() {
            const { useDocumentStore } = await import('src/store/main');
            const doc_store = useDocumentStore();
            doc_store.removeCache();

            SessionStorage.remove('view_mod');
            SessionStorage.remove('table_data');
            SessionStorage.remove('table_rows_data');
            SessionStorage.remove('enableExportButton');
            SessionStorage.remove('tbex_lineitem_headers');
            SessionStorage.remove(RULE_MANAGER);
        },

        setDataToSessionStorage(key : string, obj: any) {
            SessionStorage.set(key, obj);
        },

        getDataFromSessionByKey(key : string) {
            return SessionStorage.getItem(key);
        },
        removeDataFromSessionByKey(key : string) {
            SessionStorage.remove(key);
        },
    }
};
